export default "__VITE_ASSET__BAUQVHE7__"